"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChartStyles = void 0;
const lib_palette_1 = __importDefault(require("@opsbase/lib-palette"));
const standardFont = {
    fontFamily: 'Gilroy',
    fontWeight: 400,
    fill: lib_palette_1.default.BlackCoral.main,
};
exports.ChartStyles = {
    h1: Object.assign(Object.assign({}, standardFont), { fontSize: 13 }),
    h2: Object.assign(Object.assign({}, standardFont), { fontSize: 10, fill: lib_palette_1.default.GreyBlue.main }),
    anim: {
        duration: 400,
        delay: 0,
        onLoad: { duration: 0 },
    },
    axis: {
        stroke: lib_palette_1.default.LavendarGrey.main,
        transform: 'translate(0, 2px)',
    },
    ticks: { stroke: 'grey', size: 5 },
    tickLabels: Object.assign(Object.assign({}, standardFont), { fill: v => { var _a; return (((_a = v === null || v === void 0 ? void 0 : v.text) === null || _a === void 0 ? void 0 : _a[0]) === ' ' ? lib_palette_1.default.secondary.main : lib_palette_1.default.BlackCoral.main); }, fontWeight: v => { var _a; return (((_a = v === null || v === void 0 ? void 0 : v.text) === null || _a === void 0 ? void 0 : _a[0]) === ' ' ? 800 : 400); }, padding: 0 }),
    tickLabelsClickable: Object.assign(Object.assign({}, standardFont), { fill: v => { var _a; return (((_a = v === null || v === void 0 ? void 0 : v.text) === null || _a === void 0 ? void 0 : _a[0]) === ' ' ? lib_palette_1.default.secondary.main : lib_palette_1.default.BlackCoral.main); }, fontWeight: v => { var _a; return (((_a = v === null || v === void 0 ? void 0 : v.text) === null || _a === void 0 ? void 0 : _a[0]) === ' ' ? 800 : 400); }, cursor: 'pointer', padding: 0, transition: 'fill 0.2s, fontWeight 0.2s' }),
    tickLabelsHover: Object.assign(Object.assign({}, standardFont), { fill: lib_palette_1.default.primary.main, fontWeight: 800, padding: 0, transition: 'fill 0.2s, fontWeight 0.2s' }),
    line: {
        stroke: v => (v.datum || v.data[0]).color1 || 'black',
        strokeWidth: 2,
    },
    scatter: {
        fill: v => (v.datum || v.data[0]).color1 || 'black',
        // stroke: v => (v.datum || v.data[0]).color2 || 'black',
        // strokeWidth: 2,
    },
    data: {
        fill: v => (v.datum || v.data[0]).color1 || 'black',
        opacity: v => (v.datum || v.data[0]).opacity || 1,
        stroke: 'white',
        strokeWidth: 1,
        cursor: 'pointer',
        transition: 'opacity 0.2s, fill 0.2s',
    },
    dataHover: {
        stroke: v => (v.datum || v.data[0]).color2 || 'black',
        fill: v => (v.datum || v.data[0]).color1 || 'black',
        opacity: 0.7,
        strokeWidth: 2,
    },
    toolTipFlyout: {},
    toolTipFont: {},
};
